export const pauseOtherAudios = (refsAudios, idAudioSound) => {
    for (let i = 0; i < refsAudios.length; i++) {
        if(i === 0 || i === idAudioSound) continue;

        refsAudios[i].current.pause();
    }
}